<div
  #modalLateral
  class="modal-lateral"
  role="dialog"
  aria-labelledby="modalTitle"
  aria-describedby="modalDescription"
  tabindex="-1"
  [ngClass]="{ aberto: opcaoParaAbrir }"
  (keydown)="verificarFechamentoComEsc($event)"
>
  <div class="modal-lateral-overlay" (click)="fecharModal()" tabindex="0"></div>
  <div class="modal-lateral-conteudo" [style.width]="widthElement">
    @if (conteudoTemplate && opcaoParaAbrir) {
    <ng-template [ngTemplateOutlet]="conteudoTemplate"></ng-template>
    }
  </div>
</div>
